import PropTypes from 'prop-types';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Label, FormFeedback, Button, Alert, Container, Row, Col, Card, CardBody, Spinner } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import withRouter from "../../components/common/withRouter";
import { userForgotPassword, resetForgotPasswordState } from "../../slices/veloxity/auth/ForgotPasswordReducer";
import logoLight from "../../assets/images/logo-light.svg";
import aimeeLogo from "../../assets/images/AIMEE-LOGO.png";
import ParticlesAuth from "../authenticationInner/ParticlesAuth";

const ForgetPasswordPage = (props) => {
  const dispatch = useDispatch();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit: (values) => {
      dispatch(userForgotPassword(values));
    }
  });

  const { error, loading, errorMsg, successMsg } = useSelector((state) => state.ForgotPassword);

  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetForgotPasswordState());
      }, 3000);
    }
  }, [dispatch, errorMsg, successMsg]);

  document.title = "Reset Password | Veloxity Dashboard";

  return (
    <React.Fragment>
      <div className="bg-pattern">
      <div className="bg-overlay"></div>

    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="mt-4 card-bg-fill" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '8px', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}> {/* Genel border ve arka plan rengi */}
                <CardBody className="p-4">
                <div className="text-center mt-2">
                <img src={aimeeLogo} alt="AIMEE Logo" style={{ height: "20vh", marginBottom: "30px" }} />
              </div>
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Forgot Password?</h5>
                    <p className="text-muted">Reset password with Veloxity</p>

                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#8c68cd"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                    ></lord-icon>
                  </div>

                  <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                    Enter your email and instructions will be sent to you!
                  </Alert>
                  <div className="p-2">
                    {error && (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {errorMsg}
                      </Alert>
                    )}
                    {successMsg && (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {successMsg}
                      </Alert>
                    )}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={validation.touched.email && validation.errors.email ? true : false}
                          style={{ borderRadius: '30px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}
                        />
                        {validation.touched.email && validation.errors.email && (
                          <FormFeedback type="invalid">
                            <div>{validation.errors.email}</div></FormFeedback>
                        )}
                      </div>

                      <div className="text-center mt-4">
                        <Button color="primary" disabled={loading} className="btn btn-primary w-100" type="submit">
                          {loading ? <Spinner size="sm" /> : "Send Reset Link"}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="mb-0" style={{color: 'white'}}>
                  Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline">Click here</Link>
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      </ParticlesAuth>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
